import clsx from "clsx"
import { FC, memo } from "react"
import { ICurrencyIcon } from "@/ui/CurrencyIcon/types"
import styles from "./CurrencyIcon.module.scss"

const CurrencyIconComponent: FC<ICurrencyIcon> = ({ iconUrl, alt, size }) =>
  iconUrl ? (
    <img
      className={clsx(styles.CurrencyIcon, styles[size])}
      src={iconUrl}
      alt={alt}
      decoding="async"
    />
  ) : (
    <span
      className={clsx(styles.CurrencyIcon, styles[size], styles.placeholder)}
      role="img"
      aria-label={alt}
    />
  )

export const CurrencyIcon = memo(CurrencyIconComponent)
